<template>
    <modal :id="id" :actionButtons="false" size="md" :closeButton="true" @shown="shown" @hidden="hidden">
        <div>
            <div class="card">
                <div class="col">
                    <!-- Search -->
                    <div class="row align-items-center">
                        <div class="col-auto pr-0">
                            <span class="fe fe-x text-muted" v-if="query" @click="query=null"></span>
                            <span class="fe fe-search text-muted" v-else></span>
                        </div>
                        <div class="col">
                            <!-- <input type="search" class="form-control form-control-flush search no-glow"> -->
                            <b-form-input
                                v-model="query"
                                :autofocus="true"
                                class="no-glow search form-control-flush"
                                :placeholder="$t('Search')"
                            ></b-form-input>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="!type" class="row">
                <div class="col-6">
                    <div class="card pointer" @click="type='products';loadCategories();">
                        <div class="card-body d-flex justify-content-between align-items-center p-3">
                            <h4 class="card-title mb-1 name">{{$t('Products')}}</h4>
                            <i class="fe fe-chevron-right h1 p-0 m-0"></i>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="card pointer" @click="type='services';">
                        <div class="card-body d-flex justify-content-between align-items-center p-3">
                            <h4 class="card-title mb-1 name">{{$t('Services')}}</h4>
                            <i class="fe fe-chevron-right h1 p-0 m-0"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="type=='services' ">
                <div v-if="currentService"></div>
            </div>
            <div v-if="type=='products'">
                <div v-if="!currentCategory">
                    <div class="card mb-2" v-for="(category, categoryIndex) in categories" :key="categoryIndex">
                        <div
                            @click="currentService=null; currentCategory = category;"
                            class="card-body d-flex justify-content-between align-items-center p-2 pointer"
                        >
                            <h4 class="card-title mb-1 name">{{category.label}}</h4>
                            <i class="fe fe-chevron-right h1 p-0 m-0"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="showProducts && products.length>0" class="mb-5">
                <h4>{{$t('Products')}}</h4>
                <div class="card mb-1" v-for="product in products" :key="product._id">
                    <div
                        class="card-body d-flex justify-content-between align-items-center p-2 pointer"
                        @click.once="useProduct(product);"
                    >
                        <h4 class="card-title mb-1 name">
                            {{product.label}}
                            <p class="text-muted small mb-0 mt-1">
                                <span v-if="product.brand" class="mr-2">{{product.brand.label}}</span>
                                <money v-if="product.price" :value="product.price.retailPrice"></money>
                            </p>
                        </h4>
                        <i class="fe fe-chevron-right h1 p-0 m-0"></i>
                    </div>
                </div>
            </div>
            <div v-if="showServices && services.length>0">
                <h4>{{$t('Services')}}</h4>
                <div class="card mb-1" v-for="(service, serviceIndex) in services" :key="serviceIndex">
                    <div
                        class="card-body d-flex justify-content-between align-items-center p-2 pointer"
                        @click.prevent="currentService=service;"
                    >
                        <h4 class="card-title mb-1 name">{{service.label}}</h4>
                        <i class="fe fe-chevron-right h1 p-0 m-0"></i>
                    </div>
                </div>
            </div>
            <div v-if="showTreatments && treatments.length>0">
                <div
                    class="card mb-2"
                    v-for="(treatment, treatmentIndex) in treatments"
                    selected="true"
                    :key="treatmentIndex"
                >
                    <div
                        class="card-body d-flex justify-content-between align-items-center p-2 pointer"
                        @click="useTreatment(treatment);"
                    >
                        <h4 class="card-title mb-1 name">
                            <i
                                class="fe fe-package mr-1"
                                v-b-tooltip
                                :title="$t('Includes services or products')"
                                v-if="treatment.bundle && treatment.bundle.length>0"
                            ></i>
                            {{treatment.label}}
                            <p class="text-muted small mb-0 mt-1">
                                {{ treatment.duration | duration }}
                                <money :value="treatment.price"></money>
                            </p>
                        </h4>

                        <button class="btn">
                            <i class="fe fe-chevron-right h1 p-0 m-0"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <template slot="modal-header">
            <div class="card-header fixed" style="width:100%;">
                <div class="row align-items-center p-0">
                    <div class="col-auto p-0 m-0">
                        <button
                            type="button"
                            @click="type=null"
                            v-if="type  && (!currentService && !currentCategory)"
                            class="btn"
                        >
                            <i class="fe fe-chevron-left h1 p-0 m-0"></i>
                        </button>
                        <button
                            type="button"
                            @click="currentService=null; currentCategory = null"
                            v-if="currentService || currentCategory"
                            class="btn"
                        >
                            <i class="fe fe-chevron-left h1 p-0 m-0"></i>
                        </button>
                    </div>
                    <div class="col text-center">
                        <h4 class="card-header-title">{{ $t(title) }}</h4>
                    </div>
                    <div class="col-auto">
                        <button type="button" class="close" @click="close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>

import Modal from "@/components/Modal.vue";
import Money from "@/components/Money.vue";
import duration from '@/filters/duration.js';
import sift from "sift";
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
    name: 'item-modal',
    props: ['id', 'saveAction', 'treatmentId'],
    filters: { duration },
    components: {
        Modal,
        Money
    },
    data() {
        return {
            query: null,
            type: null,
            currentService: null,
            currentCategory: null,
            hideForm: false,
            title: 'Add item',
            productsQuery: { query: {} },
            servicesQuery: { query: {} },

        }
    },
    watch: {
        currentCategory() {
            this.loadProducts();
        },
        query(newValue) {

            this.loadProducts();

            this.servicesQuery.query.$or = [{
                label: {
                    $regex: newValue,
                    $options: "i"
                }
            },
            {
                code: {
                    $regex: newValue,
                    $options: "i"
                }
            },
            {
                description: {
                    $regex: newValue,
                    $options: "i"
                }
            },
            ];
        }
    },
    mounted() {

    },
    computed: {
        ...mapGetters('service', { findServicesInStore: 'find' }),
        ...mapGetters('products', { findProductsInStore: 'find' }),
        ...mapGetters('categories', { findCategoriesInStore: 'find' }),
        ...mapGetters('treatment', { findTreatmentInStore: 'find' }),

        showTreatments() {
            if (this.query) {
                return true;
            }
            if (this.type && this.currentService) {
                return true;
            }

            return false;
        },
        showServices() {

            if (this.currentCategory) {
                return false;
            }
            if (this.type == 'products') {
                return false;
            }

            if (this.query) {
                return true;
            }
            if (this.type && !this.currentService) {
                return true;
            }

            return false;

        },
        showProducts() {
            if (this.query) {
                return true;
            }
            if (this.currentCategory) {
                return true;
            }

            return false;

        },
        services() {
            let query = { $sort: { priority: 1 } };
            let newValue = this.query;
            if (newValue) {
                query.$or = [{
                    label: {
                        $regex: newValue,
                        $options: "i"
                    }
                },
                {
                    code: {
                        $regex: newValue,
                        $options: "i"
                    }
                },
                {
                    description: {
                        $regex: newValue,
                        $options: "i"
                    }
                }];
            }
            return this.findServicesInStore({ query: query }).data;
        },
        categories() {
            return this.findCategoriesInStore({ query: { totalProducts: { $gt: 0 } } }).data;
        },
        products() {


            return this.findProductsInStore(this.productsQuery).data;
        },

        treatments() {
            let query = {};
            let newValue = this.query;
            if (newValue) {
                query.$or = [{
                    label: {
                        $regex: newValue,
                        $options: "i"
                    }
                }];
            }

            if (this.currentService) {
                query.serviceId = this.currentService._id;
            }
            query._id = { $ne: this.treatmentId };

            return this.findTreatmentInStore({ query }).data;
        }
    },
    methods: {
        ...mapActions('products', { fetchProducts: 'find' }),
        ...mapActions('categories', { fetchCategories: 'find' }),

        loadCategories() {
            this.fetchCategories({ query: { totalProducts: { $gt: 0 } } });
        },

        loadProducts() {
            let query = {};
            let newValue = this.query;
            if (newValue) {
                query.$or = [{
                    label: {
                        $regex: newValue,
                        $options: "i"
                    }
                }];
            }

            if (this.currentCategory) {
                query.categoryId = this.currentCategory._id;
            }
            this.productsQuery.query = query;
            this.fetchProducts(this.productsQuery);
        },
        useProduct(product) {
            const data = {
                users: {},
                product: product,
                quantity: product.perServing ? product.perServing : 1,
            }
            this.$toasted.global.success({
                message: this.$t('Product has been added')
            });
            this.saveAction(data);

        },
        useTreatment(treatment) {
            const data = {
                quantity: 1,
                treatmentId: treatment._id,
                duration: treatment.duration,
                treatment: treatment,
                startAt: this.$moment(),
            }
            this.$toasted.global.success({
                message: this.$t('Item has been added')
            });
            this.saveAction(data);

        },

        treatmentsO(serviceId) {
            return this.findTreatmentInStore({
                query: {
                    serviceId
                }
            }).data;
        },
        shown() {

        },
        hidden() {
            this.type = null;
            this.currentService = null;
            this.currentCategory = null;

        },
        close() {
            this.$root.$emit('bv::hide::modal', this.id)
        },
    },

}
</script>
<style>

</style>
